module.exports = "/assets/packs/images/65d701b4d202e29c66dc933c80df0bdf.png";